import React, { useState, useEffect } from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Cancel from './../../../../../../assets/icons/close.png'
import Typography from '@mui/material/Typography'
import AutoCompleteMultiSelect from '../../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import TextAreaComponents from '../../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import TimingComponenet from '../../../../../components/TimingComponenet/TimingComponentEdit.tsx';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loadingGif from './../../../../../../assets/images/loading.gif'
import { ConstructionOutlined } from '@mui/icons-material';
import LoadingView from "../../../../../components/LoadingView/LoadingView.js";

function EditScheduler(props) {
    const apiAddress = process.env.REACT_APP_SECRET;
    console.log("ScheduleId", props.SchedulerForEdit)
    var data =
    {
        scheduleInfoView: {
            scheduleName: "string",
            shortDescription: "string",
            is24By7: true,
            creatorId: "string"
        },
        scheduleDateTimeDayMappers: []
    }

    const [Loading, setLoading] = React.useState(false);

    const handleClose = () => {
        props.onHandleAddItem(false)
    }

    const [scheduleName, setScheduleName] = useState();

    const textFieldValue = (props) => {
        console.log(props)
        setScheduleName(props)
    }

    const [loading, setloading] = useState(false);

    const saveData = (val) => {
        setloading(true);
        var valid = true;
        data.scheduleInfoView.scheduleName = scheduleName;
        data.scheduleInfoView.shortDescription = scheduleName;
        if (val.is27By7 == "SpecifyOK") {
            data.scheduleInfoView.is24By7 = false;
        }
        else {
            data.scheduleInfoView.is24By7 = true;
        }

        if (scheduleName == undefined || scheduleName == null || scheduleName == "") {
            valid = false;
            toast.error("Schedule Name Required", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }

        if (!data.scheduleInfoView.is24By7) {
            if (val.data.length <= 0) {
                valid = false;
                toast.error("Schedule can not be empty if specify is selected ", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setloading(false)
            }
        }
        data.scheduleDateTimeDayMappers = val.data;
        if (valid) {
            axios({
                method: 'put',
                url: apiAddress + '/api/Schedule/UpdateScheduler?ScheduleId=' + props.SchedulerForEdit,
                data: data
            })
                .then(function (response) {
                    setloading(false);
                    console.log(response);
                    toast.success("Successfully Saved", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    setScheduleName("");
                    data.scheduleDateTimeDayMappers = [];

                })
                .catch(function (error) {
                    setloading(false);
                    console.log(error);
                    toast.error(error.response.data, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                });
        }

    }
    const selectedData = (props) => {
        console.log("P: " + props);
    };

    useEffect(() => {
        loadSchedulerDataById(props.SchedulerForEdit)
    }, [props.SchedulerForEdit]);

    const [schedulerDetails, setSchedulerDetails] = useState(null);

    const loadSchedulerDataById = async (id) => {
        setLoading(true);

        axios({
            method: "get",
            url:
                apiAddress + "/api/Schedule/getschedulebyid?id=" + id,
        })
            .then((response) => {
                console.log("Scheduler Data", response.data)

                textFieldValue(response.data?.scheduleInfo.scheduleName)
                setSchedulerDetails(response.data);
            })
            .catch((error) => { })
            .finally(() => setLoading(false)); // Hide loader
    };

    return (
        <div>

            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}

                >
                    <LoadingView open={Loading} close={() => { setLoading(false) }} />
                    <ToastContainer />
                    <Grid container>
                        <Grid item xs={6}>
                            <DialogTitle>Edit Scheduler</DialogTitle>
                        </Grid>
                        <Grid item xs={6}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }} >

                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Schedule Name
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                {/* <TimingComponenet selectedData={selectedData}></TimingComponenet> */}
                                <TextAreaComponents label={'Schedule Name'} value={textFieldValue} val={scheduleName} />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Schedule
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <TimingComponenet selectedData={selectedData} onsubmit={saveData} loading={loading} scheduleData={schedulerDetails}></TimingComponenet>
                            </Grid>
                        </Grid>

                        {/* <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="AddItemButtons" onClick={() => saveData()}>Save</Button>
                            </Grid>
                        </Grid> */}

                    </DialogContent>
                    {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
                </Dialog>
            </React.Fragment>
        </div>
    );
}

export default EditScheduler;